export function timeout(ms, promise) {
  return new Promise(function(resolve, reject) {
    setTimeout(() => {
      reject(new Error("timeout"));
    }, ms);
    promise.then(resolve, reject);
  });
}
